var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthDecoratorLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 374,
    viewBox: "0 0 302 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 432.696,
    y: 10.6016,
    width: 50,
    height: 641.612,
    rx: 20,
    transform: "rotate(40 432.696 10.6016)",
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 412.696,
    y: 0.601562,
    width: 50,
    height: 641.612,
    rx: 20,
    transform: "rotate(40 412.696 0.601562)",
    fill: "white",
    fillOpacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthDecoratorLines);
export default __webpack_public_path__ + "static/media/auth-decorator-lines.afb357268611c220f8e5034d10f66444.svg";
export { ForwardRef as ReactComponent };